import Button from '@ui/button/Button';
import api from '@utils/api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import ProductPushRefillModal from './ProductPushRefillModal';
const ProductActionPushRefill = (props) => {
    const { t } = useTranslation();
    const [showOverlay, setShowOverlay] = useState(false);
    const [suggest, setSuggets] = useState();
    useEffect(() => {
        if (showOverlay && !suggest) {
            api.getProduct(props.refillId).then((data) => !!data && setSuggets(data));
        }
    }, [showOverlay]);
    const onClose = () => {
        setShowOverlay(false);
        api.addToBag(props.productId).then((data) => {
            if (data.error) {
                props.updateErrorMessage && props.updateErrorMessage(data.message);
            }
            else {
                (props === null || props === void 0 ? void 0 : props.pushAnalytics) && props.pushAnalytics();
                if (data.quantityTotal) {
                    const header = document.querySelector('header');
                    const firstRefine = document.querySelector('.listing-container .refine');
                    header === null || header === void 0 ? void 0 : header.style.removeProperty('transform');
                    if (firstRefine) {
                        firstRefine.style.removeProperty('transform');
                    }
                    customEventBus.emit('minicart:update', { fromAddToBag: true, fromKeyboard: false, pid: props.productId });
                }
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", cls: [props.buttonStyleInverted ? 'button--primary-inverted' : 'button--primary'], onClick: () => setShowOverlay(true) }, t('button.addtobag')),
        suggest && (React.createElement(ProductPushRefillModal, { isOpen: showOverlay, title: t('product.parfume.wantrefill'), product: suggest, onRequestClose: onClose, updateErrorMessage: props.updateErrorMessage }))));
};
export default ProductActionPushRefill;
